const AboutHero = () => {
  return <section className="relative isolate overflow-hidden bg-white py-12 sm:py-16 md:py-24 lg:py-40 xl:py-64">
            <img
    src="/images/Hiru/public_images/hiru-villa.webp"
    alt="Heilungsvolle Landschaft aus Sri Lanka"
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="eager" fetchPriority="high" />

            <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/65" />

            <div className="relative z-10 mx-auto flex max-w-6xl items-center justify-center px-3 sm:px-5 md:px-6 lg:px-8">
                <div className="relative w-full px-3 py-12 text-center sm:px-6 sm:py-14 md:px-10 md:py-18 lg:px-16 lg:py-24">
                    <div className="absolute left-4 top-6 hidden lg:block">
                        <svg width="289" height="245" viewBox="0 0 289 245" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M289 1H1V244.5" stroke="white" strokeWidth="2" />
                        </svg>
                    </div>

                    <div className="absolute -bottom-12 right-4 hidden lg:block">
                        <svg width="289" height="244" viewBox="0 0 289 244" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 243.5H288V0" stroke="white" strokeWidth="2" />
                        </svg>
                    </div>

                    <h1 className="mx-auto max-w-7xl font-serif text-2xl font-light leading-[1.2] tracking-[-0.02em] text-white drop-shadow-2xl sm:text-3xl md:text-5xl lg:text-6xl">
                        Ayurveda-Bewusstsein,
                        <br className="hidden sm:block" />
                        willkommen auf der heilenden Insel Sri Lanka
                    </h1>
                </div>
            </div>
        </section>;
};
export default AboutHero;
